/**
 * ProfileAvatar — Displays a user's profile picture or initial-based avatar.
 */

export default function ProfileAvatar({
  person,
  size = 40,
  fontSize = 16,
  color,
}) {
  if (person?.profilePicture) {
    return (
      <img
        src={person.profilePicture}
        alt={person.name}
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          objectFit: "cover",
          flexShrink: 0,
          border: `2px solid ${color || "#333"}`,
        }}
      />
    );
  }
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        background: color || "#555",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize,
        fontWeight: 700,
        color: "#fff",
        flexShrink: 0,
      }}
    >
      {person?.name?.[0]?.toUpperCase() || "?"}
    </div>
  );
}
